import loadable from '@loadable/component';
import { PageProps } from 'gatsby';
import { FormattedMessage, useIntl } from 'gatsby-plugin-react-intl';
import * as React from 'react';
import { PageHeadline } from '../components/page-headline/page-headline';
import { SEO } from '../components/seo/seo';
import { MainTemplate } from '../templates/main/main';
import { CompanyDescription } from '../ui/pages/about-us/company-description/company-description';
import { EuProgram2 } from '../ui/pages/about-us/eu-program-2/eu-program-2';
import { EuProgram3 } from '../ui/pages/about-us/eu-program-3/eu-program-3';
import { EuProgram } from '../ui/pages/about-us/eu-program/eu-program';
const CompanyVideo = loadable(
  () => import('../ui/pages/about-us/company-video/company-video')
);

const AboutUsPage = ({ location }: PageProps) => {
  const intl = useIntl();

  return (
    <MainTemplate>
      <SEO
        location={location}
        title={intl.formatMessage({ id: 'about_us.seo_title' })}
        description={intl.formatMessage({ id: 'about_us.seo_description' })}
      />
      <div className="container">
        <PageHeadline>
          <FormattedMessage id="about_us.headline" />
        </PageHeadline>
        <CompanyDescription />
        <CompanyVideo />
        <div className="row">
          <div className="col-12 col-lg-6">
            <EuProgram3 />
          </div>
          <div className="col-12 col-lg-6">
            <EuProgram2 />
          </div>
          <div className="col-12 col-lg-6">
            <EuProgram />
          </div>
        </div>
      </div>
    </MainTemplate>
  );
};

export default AboutUsPage;
